var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","small":"","disabled":_vm.selectedQuestionsForCopying.length == 0},on:{"click":_vm.copy}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-content-copy")]),_vm._v(" copy terpilih ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }